module.exports = __webpack_public_path__ + "static/img/khk001-logo_02.c31f5b44.png";